<template>
  <div>
    <div v-if="Object.keys(errors).length > 0" class="alert alert-danger">
      <p v-for="error in errors" class="errors">
        {{ error }}
      </p>
    </div>
    <div>
      <span :class="{'has-error':errors.modification}">
        <select :value="modification" name="modification" class="form-control" @change="handleChange">
          <option value="">Select a modification</option>
          <option v-for="(display, $id) in availableModifications" :value="$id">{{ display }}</option>
        </select>
      </span>
      the participant's
      <span :class="{'has-error':errors.studyVariableId}">
        <select :value="studyVariableId" name="studyVariableId" class="form-control" @change="handleChange">
          <option value="">Select Variable</option>
          <option v-for="(variable, idx) in allListVariables" :value="variable.id">{{ variable.name }}</option>
        </select>
      </span>
      variable value
      <span v-if="modification == 'set'" :class="{'has-error':errors.modificationValue}">
        to
        <select :value="modificationValue" name="modificationValue" class="form-control" @change="handleChange">
          <option value="">Select Option</option>
          <option v-for="(option) in variableValueOptions" :value="option.name">{{ option.name }}</option>
        </select>
      </span>
    </div>
  </div>
</template>

<script>
  import BaseComponent from '@/EventLogic/components/BaseComponent.vue';
  import {enumValidator} from "@/EventLogic/util";

  export default {
    extends: BaseComponent,
    props: {
      id: String,
      studyVariableId: {
        // the variable whose value will be changed
        type: [Number, String]
      },
      modification: {
        type: String,
        default: 'set',
        validator: enumValidator(['increase', 'decrease', 'set'])
      },
      modificationValue: {
        // Used by set modification
        type: String
      },
    },
    computed: {
      allListVariables: function() {
        return {...this.listVariables, ...this.orderedListVariables};
      },
      listVariables: function() {
        if (this.config.studyVariablesByType['ListVariable']) {
          return this.config.studyVariablesByType['ListVariable'];
        }
        return {};
      },
      orderedListVariables: function() {
        if (this.config.studyVariablesByType['OrderedListVariable']) {
          return this.config.studyVariablesByType['OrderedListVariable'];
        }
        return {};
      },
      variableIsOrderedList: function() {
        let selectedVariable = this.config.studyVariables[this.studyVariableId];
        if (selectedVariable) {
          return selectedVariable.type === 'OrderedListVariable';
        } else {
          return false;
        }
      },
      variableValueOptions: function() {
        let selectedVariable = this.config.studyVariables[this.studyVariableId];
        if (selectedVariable) {
          return selectedVariable.options;
        } else {
          return {};
        }
      },
      availableModifications: function() {
        if (this.variableIsOrderedList) {
          return {
            set: 'Set',
            increase: 'Raise',
            decrease: 'Lower'
          };
        } else {
          return {
            set: 'Set',
            random: 'Randomize'
          }
        }
      }
    },
    watch: {
      studyVariableId: function(newVal, oldVal) {
        const newType = this.config.studyVariables[newVal].type;
        const oldType = this.config.studyVariables[oldVal].type;
        // if we change between ordered and unordered and the modification type isn't set, reset that dropdown
        if (newType !== oldType && this.modification !== 'set') {
          this.$emit('update:modification', '');
        }
      }
    },
    methods: {
      validate: function() {
        this.errors = {};

        if (!this.isNumber(this.studyVariableId)) {
          this.errors.studyVariableId = "Please select a Variable to modify.";
        }
        if (!this.modification) {
          this.errors.modification = "Please select a modification.";
        }
        if (this.modification == 'set' && !this.modificationValue) {
          this.errors.modificationValue = "Please select a new variable value.";
        }

        return Object.keys(this.errors).length === 0;
      }
    }
  };
</script>
